import {FormInstance} from 'antd/lib/form';
import React from 'react';
import {LabelAndKey} from './types/LabelAndKey';
import GenericSelector from './GenericSelector';

interface Props {
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    criterion?: any
    form: FormInstance
}

const CohortSelector = ({dependencies, fieldValidator, criterion, form}: Props) => {

    const toLabel = (e: LabelAndKey) => {
        return e.label
    }

    return <GenericSelector
        fieldId="trackedCohort"
        fieldLabel="Previously Tracked Cohort"
        fieldURL="/cohorts"
        dependencies={dependencies}
        fieldValidator={fieldValidator}
        fieldLabelFunction={toLabel}
        criterion={criterion}
        form={form}
    />
}

export default CohortSelector